import React from 'react';
import styled from 'styled-components';

import InfoWrapper from './InfoWrapper';
import LogoWrapper from './LogoWrapper';
import SiteMap from './SiteMap';
import Pop from './AreaPop';

const FooterContent = styled.div`
  width: 100%;
  position: relative;
  padding: 3.125rem 7.5rem 4.6875rem 7.5rem;
  box-sizing: border-box;
  display: flex;
  border-top: 1px solid #ddd;
  justify-content: space-between;
  background-color: white;
`;
const FooterWrapper = styled.footer``;
const FooterSection = styled.div`
  display: flex;
  justify-content: center;
`;
const SiteMapSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface Props {
  type?: 'main' | 'sub';
}

const Footer = ({ type = 'sub' }: Props) => {
  const isMain = type === 'main';

  return (
    <FooterWrapper>
      <FooterContent>
        <FooterSection>
          <LogoWrapper />
          <InfoWrapper />
        </FooterSection>

        <SiteMapSection>
          <SiteMap />
          <br />
          {isMain && <Pop />}
        </SiteMapSection>
      </FooterContent>
    </FooterWrapper>
  );
};

export default Footer;
